define((require) => {
    "use strict";

    const Backbone                          = require("backbone");
    const BundleStrategy                    = require("data/BundleStrategy");
    const CompanySettings                   = require("shared/ui/settings/CompanySettings");
    const SalesforceCommerceSettingsModel   = require("ui/experience/widgets/salesforceCommerceWidget/model/SalesforceCommerceSettingsModel");
    const Permissions                       = require("shared/security/Permissions");
    const Syncer                            = require("shared/services/sync/Syncer");

    /**
     * Company Settings Editor Mixin functionality.
     *
     * @constructor
     */
    return CompanySettings.mixin("CompanySettingsEditorMixin", {

        relations: [
            {
                key:          "demandware",
                type:         Backbone.One,
                relatedModel: SalesforceCommerceSettingsModel
            }
        ],

        defaults: {
            version:        null,
            purgeTime:      null,
            bundleStrategy: BundleStrategy.STANDARD.name,
            imageViewedEventsEnabled: false,

            /**
             * @type {SalesforceCommerceSettingsModel}
             * SalesforceCommerce Settings for the company in question.
             */
            demandware: null // can be null if no settings available at all, use "demandware()" function to always get non-null settings
        },

        computed: {
            bundleStrategy: {
                deps: ["bundleStrategy"],
                value(bundleStrategyValue) {
                    return BundleStrategy.fromValue(bundleStrategyValue);
                }
            }
        },

        updateOnSync: ["state", "purgeTime"],

        constructor() {
            this.__super();
            Syncer.State.init(this, {
                // Settings require ADMIN privilege to change, and destroy not even supported...
                permissions: {
                    save:    Permissions.Privileges.ADMIN,
                    destroy: Permissions.Privileges.UNOBTAINABLE
                }
            });
        },

        /**
         *
         * @see {WidgetTypes.SALESFORCE_COMMERCE}
         *
         * Returns the SalesforceCommerce Settings for the company in question.
         *
         * @return {SalesforceCommerceSettingsModel} The SalesforceCommerce settings; never null.
         */
        demandware() {
            // Can be null if the company does not have any SalesforceCommerce settings at all. If null, it can never be
            // enabled anyways, so fine to return a new dummy model with disabled salesforceCommerce...
            return this.get("demandware") || new SalesforceCommerceSettingsModel();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/CompanySettingsEditorMixin.js